// Keep attachment labels aligned with the French editorial reference.
const attachments = {
  fr: {
    attachmentDocument: 'Document',
    attachmentImage: 'Image',
    attachmentPreview: 'Aperçu de {{name}}',
    attachmentPreviewLoading: 'Préparation de l’aperçu…',
    attachmentPreviewUnavailable: 'Aperçu indisponible pour ce fichier.',
    attachmentExcerpt: 'Extrait du document',
    attachmentDownload: 'Télécharger le fichier original',
  },
  en: {
    attachmentDocument: 'Document',
    attachmentImage: 'Image',
    attachmentPreview: 'Preview {{name}}',
    attachmentPreviewLoading: 'Preparing preview…',
    attachmentPreviewUnavailable: 'No preview is available for this file.',
    attachmentExcerpt: 'Document excerpt',
    attachmentDownload: 'Download the original file',
  },
  es: {
    attachmentDocument: 'Documento',
    attachmentImage: 'Imagen',
    attachmentPreview: 'Vista previa de {{name}}',
    attachmentPreviewLoading: 'Preparando la vista previa…',
    attachmentPreviewUnavailable: 'No hay vista previa disponible para este archivo.',
    attachmentExcerpt: 'Extracto del documento',
    attachmentDownload: 'Descargar el archivo original',
  },
  pt: {
    attachmentDocument: 'Documento',
    attachmentImage: 'Imagem',
    attachmentPreview: 'Pré-visualização de {{name}}',
    attachmentPreviewLoading: 'A preparar a pré-visualização…',
    attachmentPreviewUnavailable: 'Não existe pré-visualização disponível para este ficheiro.',
    attachmentExcerpt: 'Excerto do documento',
    attachmentDownload: 'Descarregar o ficheiro original',
  },
  vi: {
    attachmentDocument: 'Tài liệu',
    attachmentImage: 'Hình ảnh',
    attachmentPreview: 'Xem trước {{name}}',
    attachmentPreviewLoading: 'Đang chuẩn bị bản xem trước…',
    attachmentPreviewUnavailable: 'Không có bản xem trước cho tệp này.',
    attachmentExcerpt: 'Trích đoạn tài liệu',
    attachmentDownload: 'Tải xuống tệp gốc',
  },
  hi: {
    attachmentDocument: 'दस्तावेज़',
    attachmentImage: 'छवि',
    attachmentPreview: '{{name}} का पूर्वावलोकन',
    attachmentPreviewLoading: 'पूर्वावलोकन तैयार किया जा रहा है…',
    attachmentPreviewUnavailable: 'इस फ़ाइल का पूर्वावलोकन उपलब्ध नहीं है।',
    attachmentExcerpt: 'दस्तावेज़ का अंश',
    attachmentDownload: 'मूल फ़ाइल डाउनलोड करें',
  },
  ar: {
    attachmentDocument: 'مستند',
    attachmentImage: 'صورة',
    attachmentPreview: 'معاينة {{name}}',
    attachmentPreviewLoading: 'جارٍ تحضير المعاينة…',
    attachmentPreviewUnavailable: 'لا تتوفر معاينة لهذا الملف.',
    attachmentExcerpt: 'مقتطف من المستند',
    attachmentDownload: 'تنزيل الملف الأصلي',
  },
  ur: {
    attachmentDocument: 'دستاویز',
    attachmentImage: 'تصویر',
    attachmentPreview: '{{name}} کا پیش منظر',
    attachmentPreviewLoading: 'پیش منظر تیار کیا جا رہا ہے…',
    attachmentPreviewUnavailable: 'اس فائل کا پیش منظر دستیاب نہیں ہے۔',
    attachmentExcerpt: 'دستاویز کا اقتباس',
    attachmentDownload: 'اصل فائل ڈاؤن لوڈ کریں',
  },
};

export default attachments;
